// extracted by mini-css-extract-plugin
module.exports = {"container":"success-message_container__E2WdF","icon":"success-message_icon__ByjVQ"};